import { Button, Container, Divider, Grid, Typography } from "@mui/material"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from './home.module.css';

const RegisterButton: React.FC = () => {
    const { t } = useTranslation("home");

    return <>
        <Button 
            component={Link} 
            to="register" 
            variant="outlined" 
            size="large"
            style={{color: "white", borderColor: "white", borderRadius:"20px", textTransform:"none"}} 
            startIcon={<ArrowForwardIcon />}
        >
            {t("signUp")}
        </Button>
</>
}

export const Home = () => {
    const { t } = useTranslation("home");

    return <>
    <Container className={styles.background} maxWidth={false}><img src='images/home-background.svg' alt="background"/></Container>
    
    <Grid className={styles['home-container']} container direction='column'>
        <Container className={styles.logo} maxWidth="sm"><img src={process.env.REACT_APP_NOT_SHOW_LOGO ? "" : "images/is-logo-whiteborder.svg"} alt={process.env.REACT_APP_NOT_SHOW_LOGO ? "demo": "industrias saladillo logo"}/></Container>
        <Typography className={styles.title} variant="h5">{t("title")}</Typography>
        <RegisterButton />
        <Divider style={{ width:'90%', borderColor: 'white' }}/>
    </Grid>
</>
}